import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { UIErrorHandler } from '../../core/uiErrorHandler';
import { UIHelpers } from '../../core/ui-helpers';
import { MerchantService } from '../../models/merchant/merchantService';
import { MerchantAPIInfoData } from '../../models/merchant/merchantApiInfoData';
import { MerchantAPIScope } from '../../models/merchant/merchantAPIScope';
import { StorageService } from '../../core/storage/storageService';

@Component({
  selector: 'app-api-management',
  templateUrl: './api-management.component.html',
  standalone: false,
})
export class ApiManagementComponent {
  @Input() merchantId: string | undefined;

  merchantAPIInfoData: MerchantAPIInfoData = MerchantAPIInfoData.createEmpty();
  loading: boolean = false;

  constructor(
    private merchantService: MerchantService,
    private uiErrorHandler: UIErrorHandler,
    private storage: StorageService,
  ) {}

  formatDate(date: string | undefined): string {
    if (date) {
      return UIHelpers.formatDate(date);
    } else {
      return '';
    }
  }

  ngOnInit() {
    if (this.merchantId) {
      this.merchantService
        .getMerchantAPIInfo(this.merchantId)
        .then((data) => {
          this.merchantAPIInfoData = data;
        })
        .catch((error) => {
          this.uiErrorHandler.handleError(error);
        });
    }
  }

  ngAfterViewInit() {}

  onScopeChange(scope: MerchantAPIScope, sandbox: boolean) {
    this.loading = true;
    this.merchantService
      .updateMerchantAPIScopes(
        this.merchantAPIInfoData.clientId,
        this.merchantAPIInfoData.sandboxClientId,
        scope,
        sandbox,
      )
      .then((data) => {
        this.merchantAPIInfoData = data;
        this.loading = false;
      })
      .catch((error) => {
        this.uiErrorHandler.handleError(error);
        this.loading = false;
      });
  }

  onEnabledChange(enabled: boolean, sandbox: boolean) {
    this.merchantService
      .updateMerchantAPIAccess(
        this.merchantId!,
        this.merchantAPIInfoData.clientId,
        this.merchantAPIInfoData.sandboxClientId,
        enabled,
        sandbox,
        this.storage.getSelectedLocation()?.users[0]?.userId ?? '',
      )
      .then((data: MerchantAPIInfoData) => {
        this.merchantAPIInfoData = data;
      })
      .catch((error) => {
        this.uiErrorHandler.handleError(error);
      });
  }
}
